import React, { useEffect, useState, useRef } from "react";
import "./styles/ImageSlideshow.css";

/**
 * Auto-advancing slideshow (no manual per-photo click targets — per feedback
 * "Keine Einzelfotos zum Anklicken, sondern automatische Slideshow").
 *
 * Props:
 *  - images: [{ url, alt }]
 *  - interval: ms between slides (default 5000)
 *  - rounded: apply the site's rounded-card look (default true)
 */
export default function ImageSlideshow({ images = [], interval = 5000, rounded = true, className = "" }) {
  const [index, setIndex] = useState(0);
  const timerRef = useRef(null);
  const count = images.length;

  useEffect(() => {
    if (count <= 1) return undefined;
    timerRef.current = setInterval(() => {
      setIndex((i) => (i + 1) % count);
    }, interval);
    return () => clearInterval(timerRef.current);
  }, [count, interval]);

  if (!count) return null;

  return (
    <div className={`img-slideshow ${rounded ? "img-slideshow--rounded" : ""} ${className}`}>
      {images.map((img, i) => (
        <img
          key={img.url || i}
          src={img.url}
          alt={img.alt || ""}
          className={`img-slideshow__slide ${i === index ? "is-active" : ""}`}
          loading={i === 0 ? "eager" : "lazy"}
        />
      ))}

      {count > 1 ? (
        <div className="img-slideshow__dots" aria-hidden="true">
          {images.map((_, i) => (
            <span key={i} className={`img-slideshow__dot ${i === index ? "is-active" : ""}`} />
          ))}
        </div>
      ) : null}
    </div>
  );
}